<template>
    <section class="app-restricted">
        <template v-if="!needToDefineVatState">
            <div class="app-restricted__text">
                <h1>{{ $t('global.appRestriction.web.title') }}</h1>
                <p>{{ $t('global.appRestriction.web.description') }}</p>
            </div>

            <download-app size="large"
                :storeRegulation="currentRegulation"
            />
        </template>
    </section>
</template>

<script>
// Components
import downloadApp from '@webapp/components/download-app/download-app.vue';

// 3rd Party
import {
    mapActions,
    mapGetters,
} from 'vuex';

// Store
import sharedEpicTypes from '@shared/epics/types.js';
import localStoreTypes from '@webapp/store/types.js';
import sharedStoreTypes from '@shared/store/types.js';

export default {
    name: 'app-restricted',
    components: {
        downloadApp,
    },
    computed: {
        ...mapGetters([
            'appLoader',
            'needToDefineVatState',
            'getLatestSimpleValidationError',
            'vatState',
            'currentRegulation',
            'isUserRestricted',
        ]),
    },
    watch: {
        getLatestSimpleValidationError: 'onValidationError',

        vatState(newVal) {
            if (newVal) {
                this.resetModal();
                this.doAppDataRefresh();
                // eslint-disable-next-line
                this.$router.push('/').catch(() => {});
            }
        },
    },
    mounted() {
        if (this.appLoader.isVisible) {
            this.showAppLoader({
                isVisible: false,
            });
        }

        if (this.isUserRestricted) {
            return this.logout();
        }

        if (this.needToDefineVatState) {
            return this.setModal({
                isVisible: true,
                hasBackgroundOverlay: false,
                isClosable: false,
                componentToLoad: 'components/modals/need-to-define-vat-state',
                data: {
                    ctaOpts: {
                        text: this.$t('global.button.confirm'),
                        callback: (value) => {
                            this.updateVatInfo({
                                vatState: value.state.code,
                            });
                        },
                    },
                },
            });
        }

        this.$router.push('/home/overview');
    },
    methods: {
        ...mapActions({
            setModal: localStoreTypes.SET_MODAL,
            resetModal: localStoreTypes.RESET_MODAL,
            showAppLoader: localStoreTypes.SET_APP_LOADER,
            doAppDataRefresh: sharedEpicTypes.REFRESH_APP_DATA,
            logout: sharedStoreTypes.REMOVE_USER_AUTH,
            updateVatInfo: 'updateUserVatStateInfo',
        }),

        onValidationError(error) {
            const fetchErrors = this.utilGlobalHandleErrorMessages(error);

            this.$notify({
                type: 'error',
                text: fetchErrors.message,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.app-restricted {
    background: url("../assets/blurred-app-bg.webp") no-repeat center;
    background-size: cover;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5rem;

    @include min-width(lg) {
        justify-content: center;
        gap: 8rem;
    }

    &__text {
        color: $white-color;
        text-align: center;
        margin: 0 2rem;

        @include min-width(lg) {
            width: 40%;
            margin: 0;
        }

        h1 {
            text-transform: uppercase;
            font-size: 2.5rem;
            font-weight: 700;
            margin-top: 10rem;

            @include min-width(lg) {
                font-size: 4.5rem;
                margin-top: 0;
            }
        }

        p {
            font-size: 1.6rem;

            @include min-width(lg) {
                font-size: 2rem;
            }
        }
    }

    ::v-deep .download-app {
        flex-direction: column;
        gap: 1rem;

        @include min-width(lg) {
            flex-direction: row;
            gap: 10rem;
        }
    }
}
</style>